
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import html2canvas from "html2canvas";
import request from "@/lib/request/request";
import gateway from "@/lib/request/gateway";
import Auth from "@/lib/common/auth";
import ExamList from "@/lib/model/exam/exam";
import { ExamItem } from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import {
  CandidateMCreateParams,
  CandidateMCreateParseParams
} from "@/lib/model/exam/candidate";
import CandidateCreateForm, {
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import ModalHeader from "@/components/modal-header.vue";
import QrCodeDiy from "@/components/QrCodeDiy.vue";
import AddMoreCandidateModal from "./add-candidates.vue";
import AddOneCandidateModal from "./add-candidate.vue";

class CodeText {
  mainText = "欢迎使用AI面试"; //主标题
  subText = "快速 · 轻松 · 便捷"; //副标题
  tagShow = false;
  tagText = ""; //标签文字
  mainColor = "#5f45f2";
  subColor = "#181f71";
  logoShow = false;
  logoUrl = ""; //公司logo图片
  coderImgUrl = ""; //考试链接url
}

// 面试链接
@Component({
  components: {
    AddOneCandidateModal,
    AddMoreCandidateModal,
    ModalHeader,
    QrCodeDiy
  }
})
export default class ExamLink extends Vue {
  @Prop({ type: String, default: "邀请候选人" }) title!: string;
  @Prop({ type: String, default: "" }) link!: string;
  @Prop({ type: String, default: "" }) scanStr!: string;
  @Prop({ default: {} }) exam!: ExamItem; //面试model

  @Emit("on-success-status")
  onSuccessStatus() {
    return true;
  }

  get examId() {
    return this.exam.examId;
  }

  get examName() {
    return this.exam.name;
  }

  get connectCode() {
    return this.exam.connectCode;
  }

  show = false;
  hoverJob = new CodeText();
  codeText = new CodeText();
  editing = false;
  imgFile: any = null;
  submitting = false;

  async saveCodeText() {
    //处理空
    if (!this.codeText.mainText) {
      this.$message.warning("请输入主标题");
      return;
    }

    if (!this.codeText.subText) {
      this.$message.warning("请输入副标题");
      return;
    }

    if (!this.codeText.mainColor) {
      this.$message.warning("请选择主题色");
      return;
    }

    if (!this.codeText.subColor) {
      this.$message.warning("请选择辅助色");
      return;
    }

    if (this.codeText.tagShow && !this.codeText.tagText) {
      this.$message.warning("请输入标签文字");
      return;
    }

    if (this.codeText.logoShow && !this.codeText.logoUrl) {
      this.$message.warning("请上传logo");
      return;
    }

    this.submitting = true;

    if (!this.codeText.logoShow) {
      this.codeText.logoUrl = "";
    } else if (this.imgFile) {
      // 上传图片到oss
      await gateway
        .anonymousGetPostPolicy(this.imgFile.name)
        .then(async (postRes: any) => {
          if (!postRes) return;

          const tempUrl = `${postRes.cdn}/${encodeURIComponent(postRes.dir)}`;
          await gateway
            .upload(postRes, this.imgFile)
            .finally(() => (this.codeText.logoUrl = tempUrl));
        })
        .catch((err: any) => {
          this.$message.error(err.msg);
          this.submitting = false;
          return;
        });
    }

    await request
      .post("/aiExam/exam/qrConfigSave", {
        examId: this.examId,
        qrConfig: this.codeText
      })
      .then(() => {
        this.$message.success("保存成功");
        this.submitting = false;
        this.cancelEdit();
      })
      .catch((err: any) => {
        this.$message.error(err.msg);
        this.submitting = false;
      });
  }

  // 获取二维码配置信息
  async getCodeText(id?: number) {
    await request
      .post("/aiExam/exam/qrConfigGet", {
        examId: id || this.examId
      })
      .then((resp: any) => {
        if (resp?.data?.data?.find) {
          if (id) {
            this.hoverJob = resp.data.data.qrConfig;
            return;
          }

          this.codeText = resp.data.data.qrConfig;
        } else {
          if (id) {
            this.hoverJob = new CodeText();
            return;
          }

          this.codeText = new CodeText();
        }
      })
      .finally(() => {
        const url = `${process.env.VUE_APP_AI_INTERVIEW_HOST}/code?c=${this.connectCode}`;
        if (id) {
          this.hoverJob.coderImgUrl = url;

          try {
            setTimeout(() => {
              (this.$refs["job-pop" + id]?.[0] as any)?.getQrServe();
            }, 10);
          } catch (e) {
            console.log(e);
          }
        } else {
          this.codeText.coderImgUrl = url;
        }
      });
  }

  edit() {
    this.editing = true;
  }

  cancelEdit() {
    this.imgFile = null;
    this.getCodeText().then(() => (this.editing = false));
  }

  openFile(e: any) {
    const file = e?.target?.files?.[0];
    console.log(file);
    if (!file) {
      this.$message.warning("请选择图片");
      return;
    }
    if (!file.type.includes("image")) {
      this.$message.warning("请选择常用的图片格式");
      return;
    }
    if (file.size > 1024 * 1024 * 2) {
      this.$message.warning("图片大小不能超过2M");
      return;
    }

    this.imgFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.codeText.logoUrl = reader.result as string;
    };
  }

  //是否纯web端
  get onlyWeb() {
    return this?.exam?.platformVersion === 1;
  }

  get isInvite() {
    return this?.exam?.isNoCreateOpenJoin === 1;
  }

  async created() {
    await this.getCodeText();
    this.show = true;
  }

  @Emit("on-add-cancel")
  close() {
    return false;
  }

  copyLink() {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = this.link;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  copyLinkJob(url: string) {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = url;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  downloadBarcode(fileName = "AI面试二维码", coderAnchor = "coderAnchor") {
    this.$message.success("二维码下载中");
    const anchor = this.$refs[coderAnchor] as HTMLElement;
    // 复制一个anchor元素加入到document
    const copyAnchor = anchor.cloneNode(true) as HTMLElement;
    copyAnchor.style.position = "fixed";
    copyAnchor.style.top = "-10000px";
    copyAnchor.style.left = "-10000px";
    document.body.appendChild(copyAnchor);
    html2canvas(copyAnchor, {
      useCORS: true,
      allowTaint: true,
      scale: 3,
      scrollX: 0,
      scrollY: 0
    }).then((canvas: HTMLCanvasElement) => {
      const dataURL = canvas.toDataURL("image/jpeg");
      const a = document.getElementById("download") as HTMLAnchorElement;
      a.href = dataURL;
      a.download = fileName + ".jpeg";
      a.click();
      // 将copyAnchor移除
      document.body.removeChild(copyAnchor);
    });
  }

  // 添加候选人
  isShowAddOne = false;
  isShowAddMore = false;

  get paperId() {
    // 添加候选人弹窗用面试id
    return this.examId;
  }

  get examRemark() {
    return this.exam.remark;
  }

  candidateCreateForm = new CandidateCreateForm();
  examGetForm: ExamGetForm = new ExamGetForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();

  showAdd(key: string) {
    this.examGetForm.examId = this.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = this.examId;
    this.candidateMCreateParams.examId = String(this.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;

    if (key === "one") {
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => e.isShow == 1
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (key === "more") {
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
}
